/**
 * section-cart-drawer.js
 * Handles cart drawer open / close and focus management only.
 * All cart data operations live in cart.js.
 */

(function () {
  'use strict';

  function initCartDrawer() {
    if (typeof window.BellavoraFocusTrap === 'undefined') {
      setTimeout(initCartDrawer, 100);
      return;
    }

    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const overlay = drawer.querySelector('.js-cart-drawer-overlay');
    const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    // The panel wraps header + content — used for focus trap
    const panel = drawer.querySelector('.cart--drawer__panel');
    const cartIcon = document.querySelector('.header__cart');
    let focusTrap = null;
    let previousActiveElement = null;

    if (panel) {
      focusTrap = window.BellavoraFocusTrap.initFocusTrap(panel, { active: false });
    }

    /* ── Open ─────────────────────────────────────────────────────────── */
    function openDrawer() {
      previousActiveElement = document.activeElement;

      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
      document.body.style.overflow = 'hidden';

      if (focusTrap) focusTrap.activate();

      const firstFocusable =
        drawer.querySelector('[data-cart-drawer-close]') ||
        drawer.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }

    /* ── Close ────────────────────────────────────────────────────────── */
    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
      document.body.style.overflow = '';

      if (focusTrap) focusTrap.deactivate();

      if (previousActiveElement) {
        previousActiveElement.focus();
        previousActiveElement = null;
      }
    }

    /* ── Expose globally so cart.js / product JS can open the drawer ─── */
    window.BellavoraCart = window.BellavoraCart || {};
    window.BellavoraCart.openDrawer = openDrawer;
    window.BellavoraCart.closeDrawer = closeDrawer;

    /* ── Event listeners ─────────────────────────────────────────────── */
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Open drawer when a product is added to cart (fired by section-main-product.js etc.)
    document.addEventListener('cart:updated', function (event) {
      const detail = (event && event.detail) || {};
      const cart = detail.cart || detail;
      if (cart && cart.item_count > 0) {
        openDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
